import type { RouterOutput } from "@lattice/backend/trpc";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@lattice/frontend/components/ui/table";
import { format } from "date-fns";

export default function StockLobbyingTable({
  data,
}: {
  data: RouterOutput["stock"]["get_lobbying"];
}) {
  const grouped = Object.groupBy(data, ({ Date: date }) => date.toISOString());

  return (
    <div className="rounded-[2px] border border-primary/30 relative max-w-full max-h-full">
      <Table
        className="text-xs sm:text-sm md:text-base"
        containerClass="overflow-y-auto max-h-[600px]"
      >
        <TableHeader className="bg-primary/20 backdrop-blur-sm">
          <TableRow className="border-b-2 border-primary/30 hover:bg-transparent">
            {["Date", "Amount", "Issue", "Details", "Registrant"].map(
              (header) => (
                <TableHead
                  className="text-xs font-semibold text-foreground uppercase tracking-wider pl-5"
                  key={header}
                >
                  {header}
                </TableHead>
              ),
            )}
          </TableRow>
        </TableHeader>
        <TableBody>
          {Object.keys(grouped)
            .sort((a, b) => new Date(b).getTime() - new Date(a).getTime())
            .map((date) => {
              const items = grouped[date];

              if (!items) return null;

              return items.map((item) => {
                return (
                  <TableRow
                    key={item.id}
                    className="bg-muted/50 hover:bg-muted"
                  >
                    <TableCell className="pl-5 align-middle">
                      <span>{format(item.Date, "MMM dd, yyyy")}</span>
                    </TableCell>
                    <TableCell className="align-middle">
                      {item.Amount || "--"}
                    </TableCell>
                    <TableCell className="w-24 whitespace-normal">
                      {item.Issue ?? "--"}
                    </TableCell>
                    <TableCell>
                      <div className="w-[500px] whitespace-normal">
                        {item.Specific_Issue || "--"}
                      </div>
                    </TableCell>
                    <TableCell>{item.Registrant || "--"}</TableCell>
                  </TableRow>
                );
              });
            })}
        </TableBody>
      </Table>
    </div>
  );
}
